import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './helper/i18n';  // localization
import '@/assets/main.scss';

const savedLanguage = sessionStorage.getItem('lang') || 'ru';

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';
import { ru as vuetifyRu, en as vuetifyEn, kk as vuetifyKk } from 'vuetify/locale';  // локализация для Vuetify

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
    },
    locale: {
        locale: savedLanguage == 'en' ? 'en' : 'ru',
        fallback: 'en', // язык по умолчанию, если не найден ключ
        messages: {
            ru: vuetifyRu,
            en: vuetifyEn,
            kk: vuetifyRu
        },
    },
});

createApp(App)
    .use(store)
    .use(router)
    .use(vuetify)
    .use(i18n)
    .mount('#app');
